export default {
  '_b._qhyy': '言語切替',

  '_a._jzz': '読み込み中...',
  '_a._jzgd': 'さらに読み込む',
  '_a._wct': 'へようこそ',
  '_a._gd': 'もっと見る',
  '_a._bf': '再生',
  '_a._bcz': '保存中...',
  '_a._sctp': '画像をアップロード',

  '_dl._qssyx': 'メールアドレスを入力してください',
  '_dl._qssmm': 'パスワードを入力してください',
  '_dl._ann': 'ログイン',
  '_dl._hmyzh': 'アカウントをお持ちでない方',
  '_dl._qzc': '新規登録',
  '_dl._yzhl': '既にアカウントをお持ちの方',
  '_dl._qdl': 'ログイン',
  '_dl._srqrmm': 'パスワードを確認してください',
  '_dl._sryqm': '招待コードを入力してください',
  '_dl._sryzm': '確認コードを入力してください',
  '_dl._ljzc': '今すぐ登録',
  '_dl._zcbsty': '登録により、以下の事項に同意したものとみなされます',
  '_dl._yszc': 'プライバシーポリシー',
  '_dl._lcmmbyy': 'パスワードが一致しません',

  '_yzm._fsyzm': '確認コードを送信',
  '_yzm._cxfs': '({time}) 再送信',
  '_yzm._fsz': '送信中...',
  '_yzm._fscg': '送信成功',

  '_h._zrm': '人気',
  '_h._zxd': '新着',
  '_h._phb': 'ランキング',
  '_h._qz': '壁紙',
  '_h._ssww': '検索',
  '_h._lsjl': '履歴',
  '_h._gd': 'もっと見る',
  '_h._dl': 'ログイン',
  '_h._ye': '残高',
  '_h._dj': '凍結中',
  '_h._ybp': 'ダッシュボード',
  '_h._wdqb': 'マイウォレット',
  '_h._scjl': 'お気に入り',
  '_h._xxzx': 'メッセージセンター',
  '_h._fxhy': '友達と共有',
  '_h._bzzx': 'ヘルプセンター',
  '_h._ggtf': '広告掲載',
  '_h._bqtz': '著作権投資',
  '_h._sz': '設定',

  '_sy._jx': 'おすすめ',
  '_sy._xpfb': '新作公開',
  '_sy._gdsp': '動画をもっと見る',

  '_qz._jbqz': '精美な壁紙コレクション',
  '_qz._ssqz': '壁紙を検索',
  '_qz._qb': 'すべて',
  '_qz._zrfg': '自然風景',
  '_qz._cxys': '抽象アート',
  '_qz._csjz': '都市建築',
  '_qz._dmyx': 'アニメ＆ゲーム',
  '_qz._yzxk': '宇宙と星空',
  '_qz._yl': 'プレビュー',
  '_qz._xzqz': '壁紙をダウンロード',
  '_qz._fbl': '解像度',
  '_qz._fl': 'カテゴリ',
  '_qz._jzz': '読み込み中',
  '_qz._myzdpp': '該当する壁紙が見つかりません',

  '_sp._xyjscl': '視聴するにはロック解除が必要です',
  '_sp._cz': 'チャージ',
  '_sp._jsqj': '全エピソードをロック解除',
  '_sp._jsbj': 'このエピソードをロック解除',
  '_sp._sc': 'お気に入り',
  '_sp._fx': '共有',
  '_sp._jsqjjs': '{a}を支払って全エピソードをロック解除しますか？',
  '_sp._jsbjjs': '{a}を支払ってこのエピソードをロック解除しますか？',
  '_sp._zfz': '決済処理中...',
  '_sp._qrzf': '支払い確認',
  '_sp._qx': 'キャンセル',

  '_qz._smrc': '山岳日の出',
  '_qz._cxjh': '抽象幾何学',
  '_qz._dsyj': '都市夜景',
  '_qz._dmfj': 'アニメ風景',
  '_qz._hhxk': '広大な星空',
  '_qz._slmw': '森林の霧',
  '_qz._scld': '色彩の流れ',
  '_qz._xdjz': '現代建築',

  '_qb._cbjl': '入金履歴',
  '_qb._jyjl': '取引履歴',
  '_qb._bddz': '登録アドレス',
  '_qb._txjl': '出金履歴',

  '_m._tcdl': 'ログアウト',
  '_m._cb': '入金',
  '_m._tb': '出金',

  '_cb._ssdz': '通貨またはアドレスを検索',
  '_cb._bz': '通貨',
  '_cb._je': '金額',
  '_cb._dz': 'アドレス',
  '_cb._sj': '時間',
  '_cb._cz': '操作',
  '_cb._zwjl': '取引記録はまだありません',
  '_cb._dny': '{a} / {b} ページ',
  '_cb._jyxq': '取引詳細',
  '_cb._jydz': '取引アドレス',
  '_cb._zt': '状態',
  '_cb._yqr': '確認済み',
  '_cb._qb': 'すべて',
  '_cb._jt': '今日',
  '_cb._j7t': '過去7日間',
  '_cb._j30t': '過去30日間',
  '_cb._zw': 'なし',
  '_cb._fzcg': 'アドレスをクリップボードにコピーしました',

  '_jyjl._ssdz': '通貨またはアドレスを検索',
  '_jyjl._lx': '種類',
  '_jyjl._je': '金額',
  '_jyjl._ye': '残高',
  '_jyjl._dj': '凍結中',
  '_jyjl._sj': '時間',
  '_jyjl._cz': '操作',
  '_jyjl._zwjyjl': '取引記録はまだありません',
  '_jyjl._czsx': 'フィルターをリセット',
  '_jyjl._dny': '{a} / {b} ページ',
  '_jyjl._jyxq': '取引詳細',
  '_jyjl._jylx': '取引種類',
  '_jyjl._jyje': '取引金額',
  '_jyjl._jyhye': '取引後の残高',
  '_jyjl._djye': '凍結金額',
  '_jyjl._jysj': '取引時間',
  '_jyjl._jyzt': '取引状態',
  '_jyjl._ywc': '完了',
  '_jyjl._qb': 'すべて',
  '_jyjl._jt': '今日',
  '_jyjl._j7t': '過去7日間',
  '_jyjl._j30t': '過去30日間',

  '_jyjl._tp1': '入金',
  '_jyjl._tp2': '出金',
  '_jyjl._tp3': '支払い',
  '_jyjl._tp4': '入金',
  '_jyjl._tp5': '凍結',
  '_jyjl._tp6': '収益',
  '_jyjl._tp7': '招待報酬',
  '_jyjl._tp8': 'ログインボーナス',
  '_jyjl._tp9': 'プロモーション収益',
  '_jyjl._tp10': '動画視聴報酬',
  '_jyjl._tp11': '登録ボーナス',
  '_jyjl._tp12': '出金拒否',
  '_jyjl._tp13': 'メッセージ レッドパケット',

  '_jyjl._tp14': '内部転送',

  '_cb._shz': '審査中',
  '_cb._yyg': '承認済み',
  '_cb._ybh': '拒否',

  '_bddz._tjdz': 'アドレスを追加',
  '_bddz._ssdz': 'アドレスを検索',
  '_bddz._bz': '通貨',
  '_bddz._dz': 'アドレス',
  '_bddz._sysj': '最終使用',
  '_bddz._cz': '操作',
  '_bddz._zwjl': 'アドレス記録はまだありません',
  '_bddz._dny': '{a} / {b} ページ',
  '_bddz._dzewm': 'アドレスQRコード',
  '_bddz._fzdz': 'アドレスをコピー',
  '_bddz._dzxq': 'アドレス詳細',
  '_bddz._wl': 'ネットワーク',
  '_bddz._tjsj': '登録日時',
  '_bddz._bzwa': '備考',
  '_bddz._ntq': '{a}日前',
  '_bddz._nxsq': '{a}時間前',
  '_bddz._nfzq': '{a}分前',
  '_bddz._ngg': 'たった今',
  '_bddz._dzyfz': 'アドレスをクリップボードにコピーしました',
  '_bddz._scqr': '削除確認',
  '_bddz._scqrdz': 'このアドレスを削除してもよろしいですか？',
  '_bddz._qr': '確認',
  '_bddz._qx': 'キャンセル',
  '_bddz._scdzcg': 'アドレスの削除に成功しました',

  '_txjl._ztsx': '状態でフィルター',
  '_txjl._qbzt': 'すべての状態',
  '_txjl._shz': '審査中',
  '_txjl._ytg': '承認済み',
  '_txjl._yjj': '拒否',
  '_txjl._ssdz': 'アドレスまたは金額を検索',
  '_txjl._bz': '通貨',
  '_txjl._je': '金額',
  '_txjl._dz': 'アドレス',
  '_txjl._zt': '状態',
  '_txjl._sj': '時間',
  '_txjl._cz': '操作',
  '_txjl._zwjl': '取引記録はまだありません',
  '_txjl._czsx': 'フィルターをリセット',
  '_txjl._dny': '{a} / {b} ページ',
  '_txjl._jyxq': '取引詳細',
  '_txjl._skdz': '受取アドレス',
  '_txjl._jysj': '取引時間',
  '_txjl._jyzt': '取引状態',
  '_txjl._fzdz': 'アドレスをクリップボードにコピーしました',

  '_cbsq._bz': '通貨',
  '_cbsq._wl': 'ネットワーク',
  '_cbsq._erwm': 'QRコード',
  '_cbsq._fzdz': 'アドレスをコピー',

  '_txsq._bz': '通貨',
  '_txsq._wl': 'ネットワーク',
  '_txsq._ye': '残高',
  '_txsq._sxf': '手数料',
  '_txsq._zxtx': '最小出金額',
  '_txsq._txdz': '出金アドレス',
  '_txsq._qxztxdz': '出金アドレスを選択してください',
  '_txsq._txje': '出金額',
  '_txsq._qsrtxje': '出金額を入力してください',
  '_txsq._yxyzm': 'メール確認コード',
  '_txsq._qsryxyzm': '確認コードを入力してください',
  '_txsq._ljtx': '今すぐ出金',

  '_jl._wxhd': 'お気に入り',
  '_jl._lsjl': '履歴',

  '_xx._bt': 'メッセージセンター',
  '_xx._wjl': '記録なし',
  '_xx._zsmyxx': 'メッセージはまだありません',
  '_xx._sxxx': 'メッセージを更新',
  '_xx._sxcg': '更新成功',

  '_fx._fxhy': '友達と共有',
  '_fx._smfx': 'QRコードをスキャンして友達と共有',
  '_fx._jlsm': '報酬説明',
  '_fx._jlsm1': '1. 直接招待した友達（レベル1）から収益の{a}%を獲得',
  '_fx._jlsm2': '2. レベル1の友達が招待した友達（レベル2）から収益の{a}%を獲得',
  '_fx._jlsm3': '3. レベル2の友達が招待した友達（レベル3）から収益の{a}%を獲得',
  '_fx._fzlj': 'リンクをコピー',

  '_bzzx._bzzx': 'ヘルプセンター',
  '_bzzx._rhzczh': 'アカウント登録方法',
  '_bzzx._zclc': '登録流程',
  '_bzzx._rhzcxyh': '新規アカウントの登録方法',
  '_bzzx._rhzcxyh1': '「登録」ボタンをクリックし、メールアドレスを入力、パスワードを設定し、メール認証を完了させてアカウントを登録します。',
  '_bzzx._rhcz': 'チャージ方法',
  '_bzzx._rhcz1': 'チャージ流程',
  '_bzzx._rhcz2': '詳細なチャージ説明',
  '_bzzx._rhcz3': 'マイウォレットをクリックし、入金、希望の暗号通貨を選択し、提供されたアドレスに送信します。',

  '_bzzx._rhjsdj': 'ショートドラマのロック解除方法',
  '_bzzx._rhjsdj2': 'クリックして個々のエピソードをロック解除し、より多くのコンテンツを視聴します。',

  '_bzzx._rhtx': '出金方法',
  '_bzzx._rhtx1': '1. マイウォレット、出金アドレスに移動し、対応する暗号通貨の新しい出金アドレスを追加します。<br>2. 出金をクリックし、暗号通貨を選択し、登録済みアドレスを選択し、出金額を入力して到着を待ちます。',

  '_bzzx._qtwt': 'その他の質問',
  '_bzzx._qtwt1': 'カスタマーサービスへの連絡方法',
  '_bzzx._qtwt2': 'ウェブサイト右下のオンラインカスタマーサービス、メールまたはホットラインでご連絡ください。',
  '_bzzx._myzdwt': 'お探しの答えが見つかりませんでしたか？',
  '_bzzx._khjybbzn': 'カスタマーサービスチームがさらにサポートいたします。',
  '_bzzx._lxkf': 'カスタマーサービスに連絡',

  '_ggtf._bt1': '広告掲載',
  '_ggtf._splb': '動画リスト',
  '_ggtf._wcyd': '参加履歴',
  '_ggtf._hdbm': 'イベントコード',
  '_ggtf._tian': '日間',
  '_ggtf._kssj': '開始時間',
  '_ggtf._jssj': '終了時間',
  '_ggtf._ddvp': 'VIPレベル{a}に到達、1人あたり平均{b}回参加',
  '_ggtf._hdzt': 'イベント状態',
  '_ggtf._wks': '未開始',
  '_ggtf._ycy': '参加済み',
  '_ggtf._qg': '今すぐ購入',
  '_ggtf._mygdl': 'これ以上データはありません',
  '_ggtf._qgrtd': '購入者が多すぎます。後ほど再度お試しください',
  '_ggtf._hdxq': 'イベント詳細',
  '_ggtf._hdjs': 'イベント説明',
  '_ggtf._cyyq': '参加条件',
  '_ggtf._zdtz': '最低投資額',
  '_ggtf._vpdj': 'VIPレベル',
  '_ggtf._rjcy': '平均参加回数',
  '_ggtf._gmje': '購入金額',
  '_ggtf._qsrgmje': '購入金額を入力してください',
  '_ggtf._qx': 'キャンセル',
  '_ggtf._ljcy': '今すぐ参加',
  '_ggtf._ssjymm': '取引パスワードを入力',
  '_ggtf._qssjymm': '取引パスワードを入力してください',
  '_ggtf._ji': 'レベル',
  '_ggtf._ci': '回',
  '_ggtf._zdgm': '最低購入金額',
  '_ggtf._zggm': '最高購入金額',
  '_ggtf._zfz': '決済処理中...',

  '_wdtg._wjl': '参加記録はまだありません',
  '_wdtg._tzje': '投資金額',
  '_wdtg._zsy': '総収益',
  '_wdtg._hdts': 'イベント日数',
  '_wdtg._cysj': '参加時間',
  '_wdtg._qzf': '支払いに進む',
  '_wdtg._jxz': '進行中',
  '_wdtg._djszje': '未決済総額',
  '_wdtg._gjb': '合計{a}件',
  '_wdtg._djs': '未決済',
  '_wdtg._zrsy': '昨日の収益',
  '_wdtg._dbl': 'ビデオオンデマンド再生回数',
  '_wdtg._bfl': '再生回数',
  '_wdtg._wdsy': 'マイ収益',
  '_wdtg._bqffc': '著作権者シェア',
  '_wdtg._mr0djs': '昨日の収益は毎日0時に決算',
  '_wdtg._jrsy': '本日の収益',
  '_wdtg._mygd': 'これ以上データはありません',

  '_bqyy._bqyy': '著作権協力予約',
  '_bqyy._qrbq': '著作権協力予約申請を確認しますか？',
  '_bqyy._qx': 'キャンセル',
  '_bqyy._tjyy': '予約を提出',

  '_bqyy._spsq': '動画著作権協力申請',
  '_bqyy._spsy': '著作権者と共に動画を宣伝し、より多くのトラフィックと収益をもたらしましょう！',
  '_bqyy._ljyy': '今すぐ予約',
  '_bqyy._sphz': '動画著作権協力申請とは？',
  '_bqyy._sphzsm': '動画著作権協力申請は、相互利益のためのより多くの宣伝機会を提供します。申請を通じて、著作権者からの承認を得て、より多くの露出と収益を得る機会が得られます。',
  '_bqyy._sqhch': '著作権協力の利点',
  '_bqyy._llfz': 'トラフィックサポート',
  '_bqyy._llfzsm': 'プラットフォームの宣伝機会を得て、露出と再生回数を増加',
  '_bqyy._sytg': '収益向上',
  '_bqyy._sytgsm': 'より高い広告収入シェアとビジネス協力の機会を獲得',
  '_bqyy._yxhz': '優先協力',
  '_bqyy._yxhzsm': 'プラットフォームの公式イベントとビジネス協力プロジェクトに優先参加',
  '_bqyy._yytj': '予約条件',
  '_bqyy._sptg': '動画広告宣伝要件',
  '_bqyy._sptgsm': '少なくとも1つの動画宣告に参加し、プラットフォーム基準を満たすこと',
  '_bqyy._yysm': '予約後、スタッフが3営業日以内に連絡します',

  '_ybp._wdsy': 'マイ収益',
  '_ybp._dqye': '現在の残高',
  '_ybp._jr': '本日',
  '_ybp._jrzsy': '本日の総収益',
  '_ybp._ljzsy': '累計総収益',
  '_ybp._tgfh': '宣伝配当',
  _bqsy: '著作権収益',
  _yqfh: '招待配当',
  _mrsy: '日次収益',
  _tgsy: '宣伝収益',

  '_tjdz._tjxd': '新しいアドレスを追加',
  '_tjdz._xzbz': '通貨を選択',
  '_tjdz._qbdz': 'ウォレットアドレス',
  '_tjdz._srdz': 'ウォレットアドレスを入力してください',
  '_tjdz._qx': 'キャンセル',
  '_tjdz._bc': '保存',

  '_sz._smrz': '実名認証',
  '_sz._rzlx': '認証タイプ',
  '_sz._sfzzm': '身分証表面',
  '_sz._sfzfm': '身分証裏面',
  '_sz._zsxm': '実名',
  '_sz._qsrzsxm': '実名を入力してください',
  '_sz._sfzhm': '身分証番号',
  '_sz._qsrsfzhm': '身分証番号を入力してください',
  '_sz._yyzz': '営業許可証',
  '_sz._qymc': '企業名',
  '_sz._yyzzh': '営業許可証番号',
  '_sz._qsrqymc': '企業名を入力してください',
  '_sz._qsryyzzh': '営業許可証番号を入力してください',
  '_sz._qx': 'キャンセル',
  '_sz._tjrz': '認証を提出',
  '_sz._zt': '状態',
  '_sz._gr': '個人',
  '_sz._qy': '企業',
  '_sz._shz': '審査中',
  '_sz._ytg': '承認済み',
  '_sz._ybh': '拒否',

  '_mm._xgmm': 'パスワード変更',
  '_mm._dqxg': 'アカウント保護のため定期的にパスワードを変更',
  '_mm._dqmm': '現在のパスワード',
  '_mm._xmm': '新しいパスワード',
  '_mm._qrxmm': '新しいパスワードを確認',
  '_mm._qx': 'キャンセル',
  '_mm._qrxg': '変更を確認',

  '_jymm._xgjymm': '取引パスワード変更',

  '_szzx._sz': '設定',
  '_szzx._yrz': '認証済み',
  '_szzx._wrz': '未認証',
  '_szzx._jymm': '取引パスワード',
  '_szzx._szjymm': '取引パスワードの設定または変更',
  '_szzx._tcdl': 'ログアウト',
  '_szzx._qdtcdl': 'ログアウトしますか？',
  '_szzx._qrtc': 'ログアウト確認',
  '_szzx._qx': 'キャンセル',

  '_yj._gy': '会社概要',

  '_yj._lxwm': 'お問い合わせ',

  '_yj._yszc': 'プライバシーポリシー',

  '_yj._yhxy': '利用規約',

  '_cd._gszz': '会社の資格',

  '_cd._wmyy': '当社は業界の資格と認証をすべて取得しており、ユーザーに合法的、安全、かつ高品質なビデオサービスを提供しています',

  '_cd._yyzz': '当社の正式な登録情報と事業範囲を示す、当社の合法的な運営を証明する有効な証明書',

  '_cd._yyzz2': 'プラットフォームの合法性とコンプライアンスを保証する、合法的に取得した企業認定の事業許可証',

  '_bz._lxkf': 'カスタマーサービスへのお問い合わせは、以下をクリックするか、カスタマーサービスまでメールでお問い合わせください。ホットライン',

  '_sz._bjtx': '編集',

  '_sz._bjxx': 'メッセージを編集',

  '_sz._tx': 'アバター',

  '_sz._bcun': '保存',

  '_db._zskf': 'カスタマーサポートに連絡',
  '_db._zsry': '専属担当者',
  '_db._wdq': '未読',
  '_db._ydq': '既読',

  '_sc._sctp': '画像をアップロード',
  '_sc._xztp': '画像を選択',
  '_sc._fstp': '画像を送信',
  '_sc._qx': 'キャンセル',
  '_sc._hd': '了解',

  '_zcyl._zcbt': '登録特典',
  '_zcyl._djdkhb': 'レッドパケットをタップして開く',
  '_zcyl._zclj': '登録ボーナス',
  '_zcyl._hmyzh': 'アカウントをお持ちでない方',
  '_zcyl._qzc': '登録する',
  '_zcyl._qxdjhb': 'まず特典を受け取ってください',
  '_zcyl._qwzc': '登録へ進む',
  '_zcyl._hbysy': '特典はすでに使用済み',

  '_ggtg._qhz': '振替へ',
  '_ggtg._dqye': '現在の残高',
  '_ggtg._qcz': '入金へ',
  '_ggtg._hzje': '振替金額',
  '_ggtg._ljhz': '今すぐ振替',
  '_ggtg._yebz': '残高不足',

  '_sq._bhbt': '拒否',

  '_sq._bhyy': '拒否理由',

  '_xx._ntq': '{n}日前',

  '_xx._nxsq': '{n}時間前',

  '_xx._nfzq': '{n}分前',

  '_xx._nggq': 'たった今',

  '_xx._djckgd': 'クリックして詳細を表示',

  '_ct._zt': 'ステータス',

  '_ct._ljz': '接続中',

  '_ct._ylj': '接続済み',

  '_ct._ltlieb': 'チャットリスト',

  '_ct._bnhzj': '自分自身とチャットできません',

  '_ct._cylb': 'メンバーリスト',

  '_hb._fhb': '赤い封筒',

  '_hb._dqye': '現在の残高',

  '_hb._fsd': '送信先',

  '_hb._hbje': '赤い封筒の金額',

  '_hb._qshuru': '赤い封筒の金額を入力してください',

  '_hb._ljfs': '送信今すぐ',

  '_hb._hbz': '赤い封筒の祝福',
  '_hb._qshuruzhu': '祝福を入力してください',

  '_sp._cuow': 'エピソード1～10を視聴するにはロックを解除する必要があります',

  '_bq._tzzq': '投資期間',

  '_bq._zrsy': '昨日の利益',

  '_bq._bqtz': '著作権投資',

  '_bq._tzdj': '投資額',

  '_bq._zfjz': 'お支払いは24時間以内にお願いいたします。期限を過ぎますと、権利放棄とみなされます。',

  '_bq._qzf': 'お支払い',

  '_bq.jz': '締め切り',

  '_bq._ljzf': '今すぐお支払い',

  '_bq._sqbz': '申請メモ（任意）',

  '_bq._sqbzsm': '申請メモを入力してください',

  '_bq._zzsqz': "著作権'申請処理中、審査待ちです",

  '_app._xz': 'ReelShortBizアプリをダウンロード',

  '_app._smerm': 'QRコードをスキャンしてダウンロード',

  '_app._xzbt': 'ダウンロード',

  '_m._yhzz': '銀行振込',
  '_m._yhxx': '銀行情報',
  '_m._yhmz': '銀行名',
  '_m._yhdz': '銀行住所',
  '_m._yhmc': '氏名',
  '_m._yhzh': '口座番号',
  '_m._yhlx': '種類',
  '_m._yhly': 'ルーティング',
  '_m._yhdm': 'コード',
  '_m._yhbz': '備考',
  '_m._fzxx': '情報をコピー',

  '_m._zts': 'ヒント',

  '_m._zyd1': '1. 送金の際は、受取人の氏名、口座番号、銀行コードを必ずご確認ください。誤りがあると送金が失敗する可能性があります。',

  '_m._zyd2': '2. 送金手数料が送金銀行によって差し引かれるため、残高不足を防ぐため、「送金手数料全額負担」を選択することをお勧めします。',

  '_m._zyd3': '3. 送金には通常1～3営業日かかります。しばらくお待ちください。ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。',

  '_m._zyd4': '4. その他ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。',

  '_m._jyh': '取引番号',

  '_m._jyje': '金額',

  '_sp._dbye': 'VOD残高',
  '_sp.hzye': '振り替え',
  '_sp._txje': '振り替え金額',
  '_sp._qsrtxje': '振り替え金額を入力してください',
  '_sp._ljhz': '今すぐ振り替え',
  '_sp._yebz': '残高不足',
  '_sp._qshuru': '正しい振り替え金額を入力してください',
  '_sp._fanh': '戻る',

  '_sp._tliu': '広告配信',
  '_sp._xzgj': '国を選択',
  '_sp._cdcw': '動画エンコードエラー',
  '_ggtf._hot': '人気',
  '_tl._tlsj': '配信時間',
  '_tl._xzxb': '性別を選択',
  '_tl._nan': '男性',
  '_tl._nv': '女性',
  '_tl._hunhe': '混合',
  '_tl._xznl': '年齢を選択',
  '_sp._us': 'アメリカ',
  '_sp._en': 'イギリス',
  '_sp._jp': '日本',
  '_sp._fr': 'フランス',
  '_sp._kr': '韓国',
  '_sp._de': 'ドイツ',
  '_sp._id': 'インド',
  '_sp._in': 'インドネシア',
  '_sp._au': 'オーストラリア',
  '_sp._es': 'スペイン',
  '_sp._my': 'マレーシア',
  '_sp._cn': '中国',
  '_ggtf._fanhui': '戻る',
  '_ggtf._jymmts': '取引金額を確認してパスワードを入力してください',
  '_wdtg._wjl_desc': 'まだ広告キャンペーンに参加していません',
  '_wd._jxz': '進行中',
  '_wd._djs': '決済待ち',
  '_wd._ywc': '完了',
  '_wd._jz': '緊急',
  '_wd._hz': '振替',

  '_tl._tlfbqk': '広告費配分状況',
  '_tl._tlfbqk_desc': '1-5日:5%(コールドスタート期)、6-10日:20%(コンテンツ検証期)、11-15日:40%(IP構築期)、16-20日:35%(ショートドラママトリックス期)',

  '_nhz._sm': '送金後、金額はビデオウォレットに転送され、ビデオコンテンツのロック解除に使用されます',
  '_nhz._zhzz': '送金中...',
  '_nhz._zzcg': '送金成功',
  '_nhz._zhzsb': '送金に失敗しました。再試行してください',
  '_m._fzcg': 'コピー成功',
  '_m._fzsb': 'コピーに失敗しました。手動でコピーしてください',
  '_m._zwfzxx': 'コピーできる情報はありません',
  '_tx._qb': 'すべて',
  'activity.detail': 'アクティビティ詳細',
  'activity.noDesc': 'アクティビティの説明はありません',
  'activity.desc': 'アクティビティ説明',
  'activity.requirements': '参加条件',
  'activity.minInvest': '最低投資額',
  'activity.vipLevel': 'VIPレベル',
  'activity.avgParticipation': '平均参加回数',
  'activity.avgParticipationDesc': '回',
  'activity.country': '国を選択',
  'activity.deliveryTime': '広告配信時間',
  'activity.deliveryTimeDesc': '日',
  'activity.gender': '性別を選択',
  'activity.male': '男性',
  'activity.female': '女性',
  'activity.mixed': '混合',
  'activity.age': '年齢を選択',
  'activity.amount': '購入金額',
  'activity.back': '戻る',
  'activity.join': '今すぐ参加',
  emptyData: 'データなし',
  emptyDataDesc: '参加中の広告キャンペーンはありません',
  completedtlement: '期限切れ',
  preheat: '予熱中',
  progress: '進行中',
  settlement: '決済待ち',
  transfered: '転送済み',
  completed: '完了',
  activityCode: 'アクティビティコード',
  touzAmount: '投資金額',
  activityDays: 'アクティビティ日数',
  joinTime: '参加時間',
  playSource: '再生ソース分布',
  allPlatforms: 'すべてのプラットフォーム',
  other: 'その他',
  totalPlayNum: '総再生数',
  incomeSummary: '収益サマリー',
  totalPay: '支払った著作権料',
  totalIncome: '総収入',
  copyrightRatio: '権利者分配率',
  promotionIncome: 'プロモーション収益',
  copyrightIncome: '著作権分配',
  playNum: '再生数',
  buyNum: 'オンデマンド再生数',
  incomeRate: '分配率',
  yjIncome: '推定収入',
  paid: '支払済み',
  timeout: 'タイムアウト',
  transfer: '今すぐ転送',
  loading: '読み込み中...',
  loadMore: 'もっと読み込む',
  noMore: 'これ以上ありません',
  nightTime: '夜間帯',
  morningTime: '午前帯',
  afternoonTime: '午後帯',
  eveningTime: '夕方帯',
  '_h._tc': 'ログアウト',
  periodPayment: '期間別支払い',
  periodPaymentDesc: '1日4回、4つの期間に分けて決算されます。期間ごとに著作権料を支払うことができます',

  day: '日',
  '_dl._hy': 'おかえりなさい',
  '_dl._cj': 'アカウント作成',
  '_dl._zmm': 'パスワードをリセット',
  '_dl._hyDesc': 'アカウントにログインして、素晴らしいコンテンツを引き続き探索しましょう',
  '_dl._cjDesc': 'ReelShortBizに参加して、エキサイティングな旅を始めましょう',
  '_dl._zmmDesc': 'メールアドレスを入力すると、リセット用の確認コードを送信します',
  '_dl._hlgqsp': '豊富なHD映画・動画リソース',
  '_dl._gxhty': 'パーソナライズされたレコメンドアルゴリズム',
  '_dl._ffddsp': '多彩なショート動画',
  '_dl._dlzh': 'ログイン',
  '_dl._sdndyx': 'メールアドレスとパスワードを入力して続行',
  '_dl._email': 'メールアドレス',
  '_dl._qsryx': 'メールアドレスを入力してください',
  '_dl._dlmm': 'パスワード',
  '_dl._qsrmm': 'パスワードを入力してください',
  '_dl._wjmm': 'パスワードをお忘れですか？',
  '_dl._immdl': '今すぐログイン',
  '_dl._hmyzh2': 'アカウントをお持ちでない方',
  '_dl._ljzc2': '今すぐ登録',
  '_dl._cjzh': 'アカウント作成',
  '_dl._jswmd': 'ReelShortBizに参加して、エキサイティングな旅を始めましょう',
  '_zh._qszmm': 'パスワードを設定してください',
  '_zh._qrmm': 'パスワードを確認',
  '_zh._qmm': 'パスワードをもう一度入力してください',
  '_zc._yqm': '招待コード',
  '_zc._sryqm': '招待コードを入力してください',
  '_dl._yzm': '認証コード',
  '_dl._qsryzm': '認証コードを入力してください',
  '_dl._yjyzh': 'すでにアカウントをお持ちですか？',
  '_dl._zcbsty2': '登録することで、以下に同意したものとみなされます',
  '_dl._zcbstyDesc': 'プライバシーポリシー',
  '_dl._newmm': '新しいパスワード',
  '_dl._qszxmm': '新しいパスワードを設定してください',
  '_dl._qrmm': 'パスワードを確認',
  '_dl._qzcsrmm': '新しいパスワードをもう一度入力してください',
  '_dl._czmm': 'パスワードをリセット',
  '_dl._xqlmm': 'パスワードを思い出しましたか？',
  '_dl._fhdl': 'ログインに戻る',
  '_dl._srdllmmbyz': 'パスワードが一致しません',
  '_dl._czcg': 'パスワードが正常にリセットされました',
  '_h._zc': '登録',
  // '_ybp._wdsy': '収益',
  '_ybp._jrsy': '本日の収益',
  '_ybp._jztr': '昨日比',
  '_ybp._bfl': '再生数',
  '_ybp._dbl': 'リクエスト数',
  '_ybp._syqs': '収益トレンド',
  // '_ybp._jr': '今日',
  '_ybp._t': '日',
  // '_ybp._dqye': 'アカウント残高',
  '_ybp._djs': '未決済',
  '_ybp._zhl': 'コンバージョン率',
  '_ybp._sjgl': 'データ概要',
  '_ybp._zrsy': '昨日の収益',
  '_ybp._bysy': '今月の収益',
  '_ybp._yysj': '運用データ',
  '_ybp._zr': '昨日',
  '_ybp._zjfrs': '総有料ユーザー数',
  '_ybp._mtdqje': '明日入金予定額',
  '_ybp._jsy': '純収益',
  '_ybp._bqfy': '著作権料支払い計画',
  '_ybp._yzf': '支払済み',
  '_ybp._qzf': '支払いへ',
  '_ybp._bqfyts': '著作権料支払い後、収益と権利が優先的に保護されます',
  '_ybp._syjl': '収益履歴',
  '_ybp._ckgd': 'もっと見る',
  '_ybp._ssdt': 'ライブアップデート',
  '_ybp._bzzx': 'ヘルプセンター',
  '_ybp._lxkf': 'カスタマーサポート',
  '_ybp._zrxz': '昨日の収益',
  '_ybp._zdsy': '総収益',
  '_ybp._qygy': '先月',
  '_ybp._jsjl': '決済履歴',
  '_ybp._hzjl': '振替履歴',
  '_ybp._jfzq': '分前',
  '_ybp._fzq': '時間前',
  '_ybp._djs_mt': '明日の決済金額',
  '_yj._rule': 'プラットフォームルール',

  '_bq._jjks': '今すぐ開始',
  '_bq._jxz': '進行中',
  '_bq._jks': '開始まで',
  '_bq._jjs': '終了まで',
  '_bq._t': '日',
  '_bq._h': '時',
  '_bq._m': '分',
  '_bq._s': '秒',
  '_bq._kssj': '開始時間',
  '_bq._jssj': '終了時間',
  '_bqq._tzdj': '単価',
  '_bqq._hdts': 'イベント日数',
  '_bqq._vip': 'VIPレベル',
  '_bqq._rjcy': '平均参加数',
  '_bqq._cs': '回',
  '_bqq._ysjd': '販売進捗',
  '_bqq._ljqg': '今すぐ購入',
  '_bqq._zbkqg': '現在購入できません',
  '_bqq._jzz': '読み込み中',
  '_bqq._jzgd': 'さらに読み込む',
  '_bqq._wz': 'これ以上ありません',

  '_sp._gdsj': '全{n}話',
  '_sy._jl': '未決済記録',
  '_ybp._zsy': '総収益',
  '_ybp._djsjl': '未決済記録',
  '_ybp._bqbm': 'コード',
  '_ybp._je': '金額',
  '_ybp._sj': '時間',
  '_sy._djs': '未決済',
  '_sy._yjs': '決済済み',
  '_sy._gdstjl': '全{n}件の記録',
  '_sy._gjd': '全{n}件',

  '_sp.tgdy':'金額は{a}より低くすることはできません',
  '_sp.tggy':'金額は{a}より高くすることはできません',

  '_tg._zdyje': 'カスタム金額'
}
